import React, {ReactNode, useCallback} from 'react'
import {Placement} from 'tippy.js'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {TwMenuTab, TwMenuTabTitle} from './containers'
import {TabProps} from './types'

interface MenuTabProps extends TabProps {
  disabled?: boolean
  hintPlacement?: Placement
  lineClamp?: 2 | 3
}

export const MenuTab = ({
  id,
  title,
  onClick,
  active,
  icon,
  className,
  disabled = false,
  hint = '',
  hintPlacement,
  lineClamp
}: MenuTabProps) => {
  const titleRef = React.createRef<HTMLDivElement>()
  const [titleHint, setTitleHint] = React.useState<ReactNode>()
  const click = (e: React.MouseEvent) => {
    if (disabled) {
      return
    }
    if (onClick) {
      onClick(id, e)
    }
  }

  const onMouseEnter = useCallback(() => {
    if (titleRef.current) {
      if (titleRef.current.offsetHeight < titleRef.current.scrollHeight - 2) {
        setTitleHint(title)
      } else {
        setTitleHint('')
      }
    }
  }, [])

  const innerContent = (
    <Tooltip
      content={lineClamp ? hint || titleHint : hint}
      placement={hintPlacement}
    >
      <TwMenuTab
        $disabled={disabled}
        $active={active}
        className={className}
        onClick={click}
      >
        {icon && <Icon icon={icon} />}
        <TwMenuTabTitle
          $active={active}
          $disabled={disabled}
          $lineClamp={lineClamp}
          ref={titleRef}
        >
          {title}
        </TwMenuTabTitle>
      </TwMenuTab>
    </Tooltip>
  )

  return lineClamp ? (
    <div onMouseEnter={onMouseEnter}>{innerContent}</div>
  ) : (
    innerContent
  )
}
